/**
 * Contact multi factor authentication type
 */
export enum CONTACT_MFA_TYPE {
  TOTP = 'totp',
  // E.g. U2F, EMAIL, SMS, HOTP, etc.
}
